import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from '~/helpers/hotKeys';

const useCropModeShortcuts = ({ toggleMode }: { toggleMode?: () => void }) => {
    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || isCtrlKey(e) || e.shiftKey) {
                return;
            }

            switch (e.code) {
                case 'KeyC': {
                    toggleMode && toggleMode();

                    break;
                }

                default:
                    break;
            }
        },
        [toggleMode],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useCropModeShortcuts;
